// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
}

.container {
    background: white;
    border-radius: 20px;
    padding: 40px;
    max-width: 800px;
    width: 100%;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

h1 {
    color: #333;
    text-align: center;
    margin-bottom: 10px;
    font-size: 2.5rem;
}

.subtitle {
    text-align: center;
    color: #666;
    margin-bottom: 30px;
    font-size: 1.1rem;
}

.input-group {
    display: flex;
    gap: 10px;
    margin-bottom: 30px;
}

.video-input {
    flex: 1;
    padding: 15px 20px;
    border: 2px solid #e0e0e0;
    border-radius: 10px;
    font-size: 1rem;
    transition: border-color 0.3s;
}

.video-input:focus {
    outline: none;
    border-color: #667eea;
}

.load-button {
    padding: 15px 30px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
    border-radius: 10px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s;
}

.load-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
}

.load-button:active {
    transform: translateY(0);
}

.video-container {
    border-radius: 10px;
    overflow: hidden;
    background: #000;
    min-height: 0;
}

.video-container iframe {
    display: block;
    width: 100%;
}

.metadata-container {
    margin-top: 30px;
}

.variations-container {
    margin-top: 20px;
}

.metadata-section {
    background: #f8f9fa;
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 20px;
}

.metadata-section h3 {
    color: #333;
    margin-bottom: 15px;
    font-size: 1.3rem;
}

.metadata-content {
    display: flex;
    gap: 20px;
    align-items: start;
}

.video-thumbnail {
    width: 200px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.metadata-details {
    flex: 1;
}

.video-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
    line-height: 1.4;
}

.video-duration {
    color: #666;
    font-size: 0.95rem;
}

.duration-badge {
    display: inline-flex;
    align-items: center;
    padding: 8px 16px;
    background: linear-gradient(135deg, #6bffbf 0%, #5aee6b 100%);
    color: white;
    border: none;
    border-radius: 20px;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: default;
    box-shadow: 0 4px 12px rgba(0, 255, 162, 0.3);
    transition: transform 0.2s, box-shadow 0.2s;
    letter-spacing: 0.5px;
}

.duration-badge:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(255, 107, 107, 0.4);
}

.variations-section {
    background: #f8f9fa;
    border-radius: 10px;
    padding: 20px;
}

.variations-section h3 {
    color: #333;
    margin-bottom: 15px;
    font-size: 1.3rem;
}

.variations-list {
    list-style-position: inside;
    padding-left: 0;
}

.variations-list li {
    padding: 12px;
    margin-bottom: 10px;
    background: white;
    border-radius: 8px;
    border-left: 4px solid #667eea;
    font-size: 1rem;
    line-height: 1.5;
    transition: transform 0.2s;
}

.variations-list li:hover {
    transform: translateX(5px);
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.2);
}

.loading-indicator {
    text-align: center;
    padding: 40px 20px;
}

.spinner {
    width: 40px;
    height: 40px;
    margin: 0 auto 15px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #667eea;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.loading-indicator p {
    color: #666;
    font-size: 0.95rem;
}

.error-message {
    display: none;
    padding: 20px;
    background: #fee;
    border: 2px solid #fcc;
    border-radius: 10px;
    margin-top: 20px;
}

.error-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
}

.error-text {
    color: #c33;
    font-weight: 500;
    margin: 0;
    text-align: center;
}

.cancel-button {
    padding: 10px 24px;
    background: linear-gradient(135deg, #ff4444 0%, #cc0000 100%);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 0.95rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 2px 8px rgba(255, 68, 68, 0.3);
}

.cancel-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(255, 68, 68, 0.4);
}

.cancel-button:active {
    transform: translateY(0);
}

@media (max-width: 600px) {
    .container {
        padding: 20px;
    }

    h1 {
        font-size: 2rem;
    }

    .input-group {
        flex-direction: column;
    }

    .load-button {
        width: 100%;
    }

    .metadata-content {
        flex-direction: column;
    }

    .video-thumbnail {
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./styles.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,yGAAyG;IACzG,6DAA6D;IAC7D,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,6CAA6C;IAC7C,2CAA2C;IAC3C,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,4CAA4C;AAChD;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\nbody {\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    min-height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 20px;\n}\n\n.container {\n    background: white;\n    border-radius: 20px;\n    padding: 40px;\n    max-width: 800px;\n    width: 100%;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\nh1 {\n    color: #333;\n    text-align: center;\n    margin-bottom: 10px;\n    font-size: 2.5rem;\n}\n\n.subtitle {\n    text-align: center;\n    color: #666;\n    margin-bottom: 30px;\n    font-size: 1.1rem;\n}\n\n.input-group {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 30px;\n}\n\n.video-input {\n    flex: 1;\n    padding: 15px 20px;\n    border: 2px solid #e0e0e0;\n    border-radius: 10px;\n    font-size: 1rem;\n    transition: border-color 0.3s;\n}\n\n.video-input:focus {\n    outline: none;\n    border-color: #667eea;\n}\n\n.load-button {\n    padding: 15px 30px;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    border: none;\n    border-radius: 10px;\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.load-button:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);\n}\n\n.load-button:active {\n    transform: translateY(0);\n}\n\n.video-container {\n    border-radius: 10px;\n    overflow: hidden;\n    background: #000;\n    min-height: 0;\n}\n\n.video-container iframe {\n    display: block;\n    width: 100%;\n}\n\n.metadata-container {\n    margin-top: 30px;\n}\n\n.variations-container {\n    margin-top: 20px;\n}\n\n.metadata-section {\n    background: #f8f9fa;\n    border-radius: 10px;\n    padding: 20px;\n    margin-bottom: 20px;\n}\n\n.metadata-section h3 {\n    color: #333;\n    margin-bottom: 15px;\n    font-size: 1.3rem;\n}\n\n.metadata-content {\n    display: flex;\n    gap: 20px;\n    align-items: start;\n}\n\n.video-thumbnail {\n    width: 200px;\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.metadata-details {\n    flex: 1;\n}\n\n.video-title {\n    font-size: 1.1rem;\n    font-weight: 600;\n    color: #333;\n    margin-bottom: 10px;\n    line-height: 1.4;\n}\n\n.video-duration {\n    color: #666;\n    font-size: 0.95rem;\n}\n\n.duration-badge {\n    display: inline-flex;\n    align-items: center;\n    padding: 8px 16px;\n    background: linear-gradient(135deg, #6bffbf 0%, #5aee6b 100%);\n    color: white;\n    border: none;\n    border-radius: 20px;\n    font-size: 0.9rem;\n    font-weight: 600;\n    cursor: default;\n    box-shadow: 0 4px 12px rgba(0, 255, 162, 0.3);\n    transition: transform 0.2s, box-shadow 0.2s;\n    letter-spacing: 0.5px;\n}\n\n.duration-badge:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 16px rgba(255, 107, 107, 0.4);\n}\n\n.variations-section {\n    background: #f8f9fa;\n    border-radius: 10px;\n    padding: 20px;\n}\n\n.variations-section h3 {\n    color: #333;\n    margin-bottom: 15px;\n    font-size: 1.3rem;\n}\n\n.variations-list {\n    list-style-position: inside;\n    padding-left: 0;\n}\n\n.variations-list li {\n    padding: 12px;\n    margin-bottom: 10px;\n    background: white;\n    border-radius: 8px;\n    border-left: 4px solid #667eea;\n    font-size: 1rem;\n    line-height: 1.5;\n    transition: transform 0.2s;\n}\n\n.variations-list li:hover {\n    transform: translateX(5px);\n    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.2);\n}\n\n.loading-indicator {\n    text-align: center;\n    padding: 40px 20px;\n}\n\n.spinner {\n    width: 40px;\n    height: 40px;\n    margin: 0 auto 15px;\n    border: 4px solid #f3f3f3;\n    border-top: 4px solid #667eea;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.loading-indicator p {\n    color: #666;\n    font-size: 0.95rem;\n}\n\n.error-message {\n    display: none;\n    padding: 20px;\n    background: #fee;\n    border: 2px solid #fcc;\n    border-radius: 10px;\n    margin-top: 20px;\n}\n\n.error-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 15px;\n}\n\n.error-text {\n    color: #c33;\n    font-weight: 500;\n    margin: 0;\n    text-align: center;\n}\n\n.cancel-button {\n    padding: 10px 24px;\n    background: linear-gradient(135deg, #ff4444 0%, #cc0000 100%);\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-size: 0.95rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s;\n    box-shadow: 0 2px 8px rgba(255, 68, 68, 0.3);\n}\n\n.cancel-button:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(255, 68, 68, 0.4);\n}\n\n.cancel-button:active {\n    transform: translateY(0);\n}\n\n@media (max-width: 600px) {\n    .container {\n        padding: 20px;\n    }\n\n    h1 {\n        font-size: 2rem;\n    }\n\n    .input-group {\n        flex-direction: column;\n    }\n\n    .load-button {\n        width: 100%;\n    }\n\n    .metadata-content {\n        flex-direction: column;\n    }\n\n    .video-thumbnail {\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
